import { Organization } from "chq";

const getOrganizationSubdomain = (organization: Organization) => {
  const orgName = organization.name.replace(/\s+/g, "-")
    .replaceAll("'", "")
    .replaceAll("-+-", "and")
    .replaceAll("Activision-Blizzard", "activisionblizzard")
    .replaceAll("Talent-Acquisition-Week", "talentacquisitionweek")
    .replaceAll("West-Monroe", "westmonroe")
    .toLowerCase();

  if (window.location.host.split(".")[0].includes("-staging")) return `${orgName}-staging`;
  return orgName;
};

export default getOrganizationSubdomain;
